module.exports = __webpack_public_path__ + "img/2.731820bc.png";